module.exports = __webpack_public_path__ + "static/img/defaultMeetingCover.8b129c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultMeetingCover.png
// module id = 270S
// module chunks = 4